export default "__VITE_ASSET__DEkNj1CZ__"